import { render } from "./RuiArrowBack.vue?vue&type=template&id=4def4d28"
const script = {}
script.render = render

export default script